/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { serverlessModels } from '@fai/ssot/model-list';

export const serverlessModelPricingData = serverlessModels.map((model) => ({
  modelCode: model['Model code'],
  pricePerUnit: `$${model['Pricing']['value']}/${model['Pricing']['unit']}`,
}));
